
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spa/days/[id]",
      function () {
        return require("private-next-pages/spa/days/[id]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spa/days/[id]"])
      });
    }
  